import MDButton from "components/MDButton"
import { useNavigate } from "react-router-dom"
const BackButton=({url})=>{
    const navigate=useNavigate()
    return(
        <MDButton sx={{marginLeft:"1.5rem"}} 
        onClick={()=>{navigate(url)}} variant="outlined" color="info">Exit without save</MDButton>
    )
}

export{BackButton}